function getSessionCookie(name) {
  let cookieArr = document.cookie.split(";");

  for (let i = 0; i < cookieArr.length; i++) {
    let cookiePair = cookieArr[i].split("=");

    if (name === cookiePair[0].trim()) {
      return decodeURIComponent(cookiePair[1]);
    }
  }

  return null;
}

function setSessionCookie(name, value) {
  document.cookie = name + "=" + (value || "") + "; path=/";
}

function openSmeg() {
  if (window.location.pathname !== "/contact") {
    if (document.body.classList.contains("dataceed-backdrop")) {
      setSessionCookie("smegOpened", "true");
    }
    if (!getSessionCookie("smegOpened")) {
      window._pc.smeg.open(document.documentElement.getAttribute("lang"));
      setSessionCookie("smegOpened", "true");
    }
  }
}

setTimeout(openSmeg, 3000);
